<template>
    <div style="width:100%;height:300px;">
        <div class="iotPointsChart"></div>
    </div>
</template>

<script>

  export default {
    name: "ZEcharts",
    data: () => ({
      // 01温度 02湿度 03压强 04电流 05开关量 06三相电流 07三相电压
      // 波浪图
      waveTypeList: ['01', '04', '06', '07', '09', '10', '11', '12', '13','17','19','20','21', '22'],
      // 柱状图
      columnarTypeList: ['02', '03', '14', '15', '16', '18'],
      // 开关量
      offTypeList: ['05']
    }),
    components: {},
    props: {
      type: {
        type: String,
        default: '0',
      },
      index: {
        type: Number,
        default: 0
      },
      warningValue: {
        type: Array,
        default:()=> [99999]
      },
      warnRule: {
        type: String,
        default: ''
      },
      timeList: {
        type: Array,
        default: () => {
          return []
        }
      },
      dataList: {
        type: Array,
        default: () => {
          return []
        }
      },
      unit: {
        type: String,
        default: ''
      },
      title:{
        type: String,
        default: ''
      }
    },
    watch: {
      dataList(newValue) {
        this.setInitEcharts();
      }
    },
    methods: {
      in_array(stringToSearch, arrayToSearch) {
        for (var s = 0; s < arrayToSearch.length; s++) {
          var thisEntry = arrayToSearch[s].toString();
          if (thisEntry == stringToSearch) {
            return true;
          }
        }
        return false;
      },
      setInitEcharts() {
        var eqpChart = this.$echarts.init(document.getElementsByClassName('iotPointsChart')[this.index]);

        var options = {};

        if (this.in_array(this.type, this.waveTypeList)) {
          // 波浪图样式
          options = {
            title: {
              text: this.title,
              left: 'center'
            },
            tooltip: {
              backgroundColor: 'transparent',
              color: '#fff',
              trigger: 'axis',
              padding: [2, 10],
              textStyle: {
                fontSize: 16
              },
              formatter: (params) => {
                var str = '';
                if (params[0].data.isWarning) {
                  str = `<div style="font-size:0.875rem;border-radius:0.2rem;padding:0 0.5rem;background-color:#FF6C00;"><div>${params[0].axisValue}</div>
<div>${params[0].data.value}${this.unit}</div>
<div>`
                  if (params[0].data.beforeWarningValue) {
                    str = str + `<div><span>预警前采集数值: </span><span>${params[0].data.beforeWarningValue}${this.unit}</span></div>`;
                  }
                  if (params[0].data.startWarningValue) {
                    str = str + `<div><span>开始预警数值: </span><span>${params[0].data.startWarningValue}${this.unit}</span></div>`;
                  }
                  if (params[0].data.endWarningValue) {
                    str = str + `<div><span>预警最后一次数值: </span><span>${params[0].data.endWarningValue}${this.unit}</span></div>`;
                  }
                  if (params[0].data.afterWarningValue) {
                    str = str + `<div><span>预警后采集数值: </span><span>${params[0].data.afterWarningValue}${this.unit}</span></div>`;
                  }
                  str = str + `</div></div>`
                } else {
                  str = `<div style="border-radius:0.2rem;padding:0 0.5rem;background-color:#0057FF"><div>${params[0].axisValue}</div>
<div>${params[0].data.value}${this.unit}</div></div>`
                }
                return str
              }
            },
            xAxis: {
              type: 'category',
              splitLine: {
                show: false
              },
              axisLine: {
                lineStyle: {
                  // width: 3,
                  color: '#D3D3D3'
                }
              },
              // axisTick: {
              //   show: true,
              //   alignWithLabel: true,
              //   lineStyle: {
              //     width:3
              //   }
              // },
              axisLabel: {
                // rotate: 45,
                // fontWeight: "bold",
                color: '#333',
                formatter: function (value) {
                  return value.split(" ")[0]+'\n'+value.split(" ")[1];
                }
              },
              // 从原点开始设置值
              boundaryGap: false,
              data: this.timeList
            },
            grid: {
              // left: '2%',
              // right: '2%',
              top: '4%',
              // bottom: '4%',
              // containLabel: true
            },
            yAxis: {
              type: 'value',
              // name: 'M',
              splitLine: {
                show: true,
                lineStyle: {
                  type: 'dashed'
                }
              },
              axisLabel: {
                textStyle: {
                  color: '#333'
                },
                fontWeight: 'bold',
              },
              axisLine: {
                lineStyle: {
                  color: '#D3D3D3',
                },
              },
              axisTick: {
                lineStyle: {
                  // width: 3
                }
              },
            },
            series: [
              {
                type: 'line',
                symbol: 'circle',
                symbolSize: 5,
                smooth: true,
                animationDuration: 2000,
                itemStyle: {
                  normal: {
                    color: (param) => {
                      // if (param.data.value > this.warningValue||param.data.isWarning) {
                      if (param.data.isWarning) {
                        return '#FF7E00'
                      } else {
                        return 'blue'
                      }
                    },
                    shadowBlur: 2,
                    shadowColor: "rgba(0, 0, 0, .12)",
                    shadowOffsetX: 2,
                    shadowOffsetY: 2
                  }
                },
                lineStyle: {
                  normal: {
                    color: "#0057FF",
                    width: 1,
                    shadowColor: 'rgba(0,0,0,0.4)',
                    shadowBlur: 3,
                    shadowOffsetX: 4,
                    shadowOffsetY: 4
                  }
                },
                data: this.dataList,
                markLine: {
                  silent: true,
                  lineStyle: {
                    color: '#FF7E00'
                  },
                  label: {
                    show: false
                  },
                    data:this.warningValue.length == 1 ?[{yAxis: this.warningValue[0]}] : [{yAxis: this.warningValue[0]},{yAxis: this.warningValue[1]}]
                },
                areaStyle: {
                  color: 'rgba(0,87,255,0.3)',
                },
              },]
          };
        } else if (this.in_array(this.type, this.columnarTypeList)) {
          // 柱状图样式
          options = {
            backgroundColor: 'transparent',
            tooltip: {
              backgroundColor: 'transparent',
              color: '#fff',
              trigger: 'axis',
              padding: [2, 10],
              textStyle: {
                fontSize: 16
              },
              formatter: (params) => {
                var str = '';
                if (params[0].data.isWarning) {
                  str = `<div style="font-size:0.875rem;border-radius:0.2rem;padding:0 0.5rem;background-color:#FF6C00;"><div>${params[0].axisValue}</div>
<div>${params[0].data.value}${this.unit}</div>
<div>`
                  if (params[0].data.beforeWarningValue) {
                    str = str + `<div><span>预警前采集数值: </span><span>${params[0].data.beforeWarningValue}${this.unit}</span></div>`;
                  }
                  if (params[0].data.startWarningValue) {
                    str = str + `<div><span>开始预警数值: </span><span>${params[0].data.startWarningValue}${this.unit}</span></div>`;
                  }
                  if (params[0].data.endWarningValue) {
                    str = str + `<div><span>预警最后一次数值: </span><span>${params[0].data.endWarningValue}${this.unit}</span></div>`;
                  }
                  if (params[0].data.afterWarningValue) {
                    str = str + `<div><span>预警后采集数值: </span><span>${params[0].data.afterWarningValue}${this.unit}</span></div>`;
                  }
                  str = str + `</div></div>`
                } else {
                  str = `<div style="border-radius:0.2rem;padding:0 0.5rem;background-color:#0057FF"><div>${params[0].axisValue}</div>
<div>${params[0].data.value}${this.unit}</div></div>`
                }
                return str
              }
            },
            grid: {
              // left: '2%',
              // right: '2%',
              top: '4%',
              // bottom: '4%',
              // containLabel: true
            },
            xAxis: {
              data: this.timeList,
              axisTick: {show: true},
              axisLine: {
                show: true,
                lineStyle: {
                  // width: 3,
                  color: '#D3D3D3'
                }
              },
              axisLabel: {
                color: '#333',
                formatter: function (value) {
                  return value.split(" ")[0]+'\n'+value.split(" ")[1];
                }
              },
            },
            yAxis: {
              name: '单位:亿元',
              nameLocation: 'end',
              nameGap: '10',
              nameTextStyle: {
                color: '#fff',
                fontSize: '10',
              },
              splitLine: {
                lineStyle: {
                  color: 'rgba(160,160,160,0.3)',
                }
              },
              axisTick: {show: false},
              axisLabel: {
                textStyle: {
                  color: '#333'
                },
                fontWeight: 'bold'
              },
              axisLine: {
                lineStyle: {
                  color: 'rgba(160,160,160,0.3)',
                }
              },
            },
            series: [{
              type: 'bar',
              data: this.dataList,
              barWidth: '20px',
              itemStyle: {
                normal: {
                  color: (param) => {
                    if (param.data.isWarning) {
                      return new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#FFA500' // 0% 处的颜色
                      }, {
                        offset: 1,
                        color: '#FF6C00' // 50% 处的颜色
                      }], false)
                    } else {
                      return new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#0057FF' // 0% 处的颜色
                      }, {
                        offset: 1,
                        color: '#00C4FF' // 50% 处的颜色
                      }], false)
                    }
                  }
                }
              },
              markLine: {
                silent: true,
                lineStyle: {
                  color: '#FF7E00'
                },
                label: {
                  show: false
                },
                  data:this.warningValue.length == 1 ?[{yAxis: this.warningValue[0]}] : [{yAxis: this.warningValue[0]},{yAxis: this.warningValue[1]}]
              },
            }]
          };
        } else if (this.in_array(this.type, this.offTypeList)) {
          // 开关量图样式
          options = {
            title: {
              text: this.title,
              left: 'center'
            },
            tooltip: {
              backgroundColor: 'transparent',
              color: '#fff',
              trigger: 'axis',
              padding: [2, 10],
              textStyle: {
                fontSize: 16
              },
              formatter: (params) => {
                var str = '';
                if (params[0].data.isWarning) {
                  str = `<div style="font-size:0.875rem;border-radius:0.2rem;padding:0 0.5rem;background-color:#FF6C00;"><div>${params[0].axisValue}</div>
<div>${params[0].data.value}${this.unit}</div>
<div>`
                  if (params[0].data.beforeWarningValue) {
                    str = str + `<div><span>预警前采集数值: </span><span>${params[0].data.beforeWarningValue}${this.unit}</span></div>`;
                  }
                  if (params[0].data.startWarningValue) {
                    str = str + `<div><span>开始预警数值: </span><span>${params[0].data.startWarningValue}${this.unit}</span></div>`;
                  }
                  if (params[0].data.endWarningValue) {
                    str = str + `<div><span>预警最后一次数值: </span><span>${params[0].data.endWarningValue}${this.unit}</span></div>`;
                  }
                  if (params[0].data.afterWarningValue) {
                    str = str + `<div><span>预警后采集数值: </span><span>${params[0].data.afterWarningValue}${this.unit}</span></div>`;
                  }
                  str = str + `</div></div>`
                } else {
                  str = `<div style="border-radius:0.2rem;padding:0 0.5rem;background-color:#0057FF"><div>${params[0].axisValue}</div>
<div>${params[0].data.value == 0 ? '关' : '开'}</div></div>`
                }
                return str
              }
            },
            grid: {
              // left: '0%',
              // right: '2%',
              top: '4%',
              // bottom: '4%',
              // containLabel: true
            },
            xAxis: {
              type: 'category',
              splitLine: {
                show: false
              },
              // 从原点开始设置值
              boundaryGap: false,
              axisLine: {
                show: true,
                lineStyle: {
                  // width: 3,
                  color: '#D3D3D3'
                },
                onZero: false
              },
              axisTick: {
                show: true,
                alignWithLabel: true,
                lineStyle: {
                  width: 3
                }
              },
              axisLabel: {
                color: '#333',
                formatter: function (value) {
                  return value.split(" ")[0]+'\n'+value.split(" ")[1];
                }
              },
              data: this.timeList
            },
            // visualMap: [{
            //   show: false,
            //   pieces: [{
            //     gte: 0,
            //     lt: 0.99,
            //     color: '#FF7800'
            //   }, {
            //     gt: 0,
            //     lte: 1.1,
            //     color: '#0057FF'
            //   }],
            //   seriesIndex: 0
            // }],
            yAxis: {
              splitNumber: 2,
              type: 'value',
              // name: 'M',
              min: -1,
              axisLine: {
                show: false,
                // onZero: false
              },
              splitLine: {
                show: true,
                lineStyle: {
                  // color: 'rgba(255,255,255,0.1)'
                  type: 'dashed',
                }
              },
              axisTick: {
                lineStyle: {
                  width: 3
                }
              },
              axisLabel: {
                show: true,
                margin: 15,
                textStyle: {
                  color: '#333'
                },
                fontWeight: 'bold',
                formatter: (value) => {
                  if (value == 0) {
                    return '关'
                  } else if (value == 1) {
                    return '开'
                  }
                }
              },
            },
            series: [{
              type: 'line',
              symbol: 'circle',
              symbolSize: 5,
              smooth: false,
              animationDuration: 2000,
              itemStyle: {
                normal: {
                  color: (param) => {
                    if (param.data.isWarning) {
                      return '#FF7E00'
                    } else {
                      return '#0057FF'
                    }
                  },
                  shadowBlur: 2,
                  shadowColor: "rgba(0, 0, 0, .12)",
                  shadowOffsetX: 2,
                  shadowOffsetY: 2
                }
              },
              lineStyle: {
                normal: {
                  // type: 'dashed',
                  width: 1,
                  shadowColor: 'rgba(0,0,0,0.4)',
                  shadowBlur: 5,
                  shadowOffsetX: 4,
                  shadowOffsetY: 5
                }
              },
              data: this.dataList,
              markLine: {
                silent: true,
                lineStyle: {
                  color: '#FF7E00'
                },
                label: {
                  show: false
                },

                  data:this.warningValue.length == 1 ?[{yAxis: this.warningValue[0]}] : [{yAxis: this.warningValue[0]},{yAxis: this.warningValue[1]}]
              },
            },]
          }
        }

        eqpChart.setOption(options, true);
        window.addEventListener("resize", function () {
          eqpChart.resize();
        });

      },
    },
    mounted() {
      this.setInitEcharts();
    },
    created() {

    }
  }
</script>

<style scoped>
    .iotPointsChart {
        width: 100%;
        height: 100%;
    }
</style>